import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const scenarioNamespace = 'scenario';

export const excludeWorkspaceFromScenario = actionCreator<{
  scenarioId: ArdoqId;
  workspaceId: ArdoqId;
}>('[workspaceModelEditor] EXCLUDE_WORKSPACE_FROM_SCENARIO');
